// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__pZGph","label":"Labeled_label__hrKkK","divider":"Labeled_divider__1xFs3"};